<template>
  <!-- qq 企点 -->
  <div class="QQCS">
    <a
      v-if="show"
      target="_blank"
      class="QQCSlink"
      :href="getHref()"
    ><img
      class="avatar"
      src="//bqq.gtimg.com/qidian/src/sites/srv/wpa/conf/wpa/avatar/2-1.png"
    ><span
      class="icon-qq"
      :style="{
        background: `url(${getImg()})  no-repeat`
      }"
    /><span class="title">在线咨询</span>
      <span v-if="!isEmpty(kfdh)" class="signature" style="font-weight: bold;font-size: 15px;">客服热线&nbsp;{{ kfdh }}</span>
      <span v-if="!isEmpty(kfdh)" class="signature" style="top:70px;">服务时间&nbsp;8:30-17:00</span>
      <span v-else class="signature">服务时间&nbsp;8:30-17:00</span>
    </a>
    <a
      v-else
      class="QQCSlinkMin"
      target="_blank"
      :href="getHref()"
    >
      <img
        class="icon-qq"
        :style="{
          background: `url(${getImg()})  no-repeat;`
        }"
        :src="getImg()"
      >
    </a>
    <i
      :class="!show ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
      @click="show = !show"
    />
  </div>
</template>

<script>
import {
  isEmpty
} from '@/utils/tool'
export default {
  props: {
    zxfwUrl: { type: String, default: '' },
    kfdh: { type: String, default: '' },
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    isEmpty(obj) {
      return typeof obj === 'undefined' || obj == null || obj === ''
    },
    getHref() {
      return isEmpty(this.zxfwUrl) ? 'https://wpa1.qq.com/eZIgTlah?_type=wpa&qidian=true' : this.zxfwUrl
    },
    getImg() {
      return isEmpty(this.zxfwUrl) ? 'https://bqq.gtimg.com/qidian/src/wpa/dist/4.1.0/images/1_4.png' : this.zxfwUrl.indexOf('weixin') !== -1 ? require('../../assets/img/weixin.png') : 'https://bqq.gtimg.com/qidian/src/wpa/dist/4.1.0/images/1_4.png'
    }
  }
}
</script>

<style lang="less">
.QQCS {
  position: fixed;
  z-index: 9999;
  right: 10px;
  top: 190px;
  border-radius: 2px;
  background: #fff;
  box-shadow: 0 1px 3px rgb(30 36 49 / 15%);
  border: 1px solid #dadee7;
  user-select:none;
  i {
    position: absolute;
    right: 0px;
    width: 20px;
    height: 100%;
    line-height: 80px;
    text-align: center;

    &:hover {
      background-color: rgba(0, 0, 0, 0.11);
      cursor: pointer;
    }
  }
  .QQCSlinkMin {
    display: inline-block;
    *zoom: 1;
    *display: inline;
    height: 90px;
    width: 50px;
    .icon-qq {
      display: inline-block;
      *zoom: 1;
      *display: inline;
      width: 22px;
      height: 22px;
      position: absolute;
      left: 6px;
      top: 30px;
    }
  }
  .QQCSlink {
    display: inline-block;
    *zoom: 1;
    *display: inline;
    width: 300px;
    height: 90px;

    font-family: "microsoft yahei";
    font-size: 14px;

    cursor: pointer;
    .avatar {
      width: 85px;
      height: 90px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .icon-qq {
      display: inline-block;
      *zoom: 1;
      *display: inline;
      width: 22px;
      height: 22px;
      position: absolute;
      left: 97px;
      top: 18px;
    }
    .title {
      display: inline-block;
      *zoom: 1;
      *display: inline;
      word-break: break-all;
      word-wrap: break-word;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      max-width: 125px;
      font-size: 20px;
      position: absolute;
      left: 126px;
      top: 16px;
      color: #1e2330;
    }
    .signature {
      display: inline-block;
      *zoom: 1;
      *display: inline;
      word-break: break-all;
      word-wrap: break-word;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      max-width: 200px;
      position: absolute;
      left: 97px;
      top: 50px;
      text-align: left;
    color: #333;
    }
  }
}
</style>
